import React, { forwardRef, TextareaHTMLAttributes } from 'react';

import { cn } from '@utils/index';
interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  className?: string;
  error?: boolean;
}

const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, error, disabled, ...props }, ref) => {
    return (
      <textarea
        ref={ref}
        className={cn(
          'flex min-h-[80px] w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-base',
          'placeholder:text-[#a6a5a0] focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent',
          'disabled:cursor-not-allowed disabled:bg-gray-100 disabled:opacity-50',
          error && 'border-red-500 focus:ring-red-500',
          className
        )}
        disabled={disabled}
        {...props}
      />
    );
  }
);

Textarea.displayName = 'Textarea';

export { Textarea };
